import If from './If'
import React, { Component } from 'react';

class IconMenuSvg extends Component {
  constructor(props) {
    super(props);

    this.state = {
      icon: this.props.icon,
    }
  }

  render() {
    return (
      <div>
        <If test={this.props.icon == 'treino'}>
          <svg className="svg-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 388.297 388.297">
            <g>
              <rect x="0" y="134.514" width="64.902" height="119.269"/>
              <polygon points="243.936,178.815 144.359,178.815 144.359,104.148 79.456,104.148 79.456,284.148 144.359,284.148 144.359,209.481
                243.936,209.481 243.936,284.148 308.841,284.148 308.841,104.148 243.936,104.148"/>
              <rect x="323.395" y="134.514" width="64.902" height="119.269"/>
            </g>

          </svg>
        </If>
        <If test={this.props.icon == 'alunos'}>
          <svg className="svg-icon" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            width="80.13px" height="80.13px" viewBox="0 0 80.13 80.13">
            <g>
              <path d="M48.355,17.922c3.705,2.323,6.303,6.254,6.776,10.817c1.511,0.706,3.188,1.112,4.966,1.112c6.491,0,11.752-5.261,11.752-11.751c0-6.491-5.261-11.752-11.752-11.752C53.668,6.35,48.453,11.517,48.355,17.922z M40.656,41.984c6.491,0,11.752-5.262,11.752-11.752s-5.262-11.751-11.752-11.751c-6.49,0-11.754,5.262-11.754,11.752S34.166,41.984,40.656,41.984z M45.641,42.785h-9.972c-8.297,0-15.047,6.751-15.047,15.048v12.195l0.031,0.191l0.84,0.263c7.918,2.474,14.797,3.299,20.459,3.299c11.059,0,17.469-3.153,17.864-3.354l0.785-0.397h0.084V57.833C60.688,49.536,53.938,42.785,45.641,42.785z M65.084,30.653h-9.895c-0.107,3.959-1.797,7.524-4.47,10.088c7.375,2.193,12.771,9.032,12.771,17.11v3.758c9.77-0.358,15.4-3.127,15.771-3.313l0.785-0.398h0.084V45.699C80.13,37.403,73.38,30.653,65.084,30.653z M20.035,29.853c2.299,0,4.438-0.671,6.25-1.814c0.576-3.757,2.59-7.04,5.467-9.276c0.012-0.22,0.033-0.438,0.033-0.66c0-6.491-5.262-11.752-11.75-11.752c-6.492,0-11.752,5.261-11.752,11.752C8.283,24.591,13.543,29.853,20.035,29.853z M30.589,40.741c-2.66-2.551-4.344-6.097-4.467-10.032c-0.367-0.027-0.73-0.056-1.104-0.056h-9.971C6.75,30.653,0,37.403,0,45.699v12.197l0.031,0.188l0.84,0.265c6.352,1.983,12.021,2.897,16.945,3.185v-3.683C17.818,49.773,23.212,42.936,30.589,40.741z"/>
            </g>
          </svg>
        </If>
        <If test={this.props.icon == 'calendario'}>
          <svg className="svg-icon" version="1.1" id="Capa_1" x="0px" y="0px"
              viewBox="0 0 512 512">
              <g>
                <path d="M452,40h-24V0h-40v40H124V0H84v40H60C26.916,40,0,66.916,0,100v352c0,33.084,26.916,60,60,60h392
                  c33.084,0,60-26.916,60-60V100C512,66.916,485.084,40,452,40z M472,452c0,11.028-8.972,20-20,20H60c-11.028,0-20-8.972-20-20V188
                  h432V452z M472,148H40v-48c0-11.028,8.972-20,20-20h24v40h40V80h264v40h40V80h24c11.028,0,20,8.972,20,20V148z"/>
              </g>
              <g>
                <g>
                  <rect x="76" y="230" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="156" y="230" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="236" y="230" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="316" y="230" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="396" y="230" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="76" y="310" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="156" y="310" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="236" y="310" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="316" y="310" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="76" y="390" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="156" y="390" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="236" y="390" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="316" y="390" width="40" height="40"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="396" y="310" width="40" height="40"/>
                </g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
          </svg>
        </If>
        <If test={this.props.icon == 'home'}>
        <svg className="svg-icon" version="1.1" id="Capa_1" x="0px" y="0px"
              width="495.398px" height="495.398px" viewBox="0 0 495.398 495.398">
             <g>
                <path d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
                  v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
                  c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
                  c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"/>
                <path d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
                  c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
                  c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"/>
              </g>
          </svg>
        </If>
      </div>
    );
  }
}

export default IconMenuSvg;


// WEBPACK FOOTER //
// src/utils/icons-menus-svg.js